import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/index')
  },
  {
    path: '/page-error',
    name: 'error',
    component: () => import('../views/page-error')
  },
  {
    path: '/page-contact-detail',
    name: 'contact-detail',
    component: () => import('../views/page-contact-detail')
  },
  {
    path: '/contact-us',
    name: 'contact-us',
    component: () => import('../views/page-contact-detail')
  },
  {
    path: '/products/sharp',
    name: 'product-sharp',
    component: () => import('../views/product-sharp')
  },
  {
    path: '/products/konica-minolta',
    name: 'product-konica-minolta',
    component: () => import('../views/product-konica-minolta')
  },
  {
    path: '/products/lexmark',
    name: 'product-lexmark',
    component: () => import('../views/product-lexmark')
  },
  {
    path: '/products/hp',
    name: 'product-hp',
    component: () => import('../views/product-hp')
  },
  {
    path: '/products/brother',
    name: 'product-brother',
    component: () => import('../views/product-brother')
  },
  // Catch-all route must be last
  {
    path: '*',
    component: () => import('../views/page-error')
  },
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
